import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid";
import { Text } from "framework/validators/TextValidation";
import { useState } from "react";
import ReactPaginate from "react-paginate";
import { Button, Col, Row } from "reactstrap";



export const ProductCustomerBarcode = ({ customerBarcodeList, setCustomerBarcodeList, Disabled }) => {

    const [postsPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)

    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = customerBarcodeList.slice(indexOfFirstPost, indexOfLastPost)

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    function RemoveRow(index) {
        var temp = [...customerBarcodeList]
        temp.splice(index, 1)
        setCustomerBarcodeList(temp)
    }

    function RowOnchange(value, name, index) {
        var temp = [...customerBarcodeList]
        temp[index][name] = value
        setCustomerBarcodeList(temp)
    }


    function UpdateRow(index, item) {
        var temp = [...customerBarcodeList]
        temp[index] = item
        setCustomerBarcodeList(temp)
    }


    function AddNewRow() {
        var temp = [...customerBarcodeList]
        temp.push({ customerCode: "", customerName: "", barcode: "" })
        setCustomerBarcodeList(temp)
    }

    return (
        <div>
            <Row>
                <Col sm={12} md={6} className="mb-12-sm">
                    <div className="table-responsive">
                        <table className="table table-bordered  table-sm rounded  mb-0">
                            <thead className="thead-light">
                                <tr>
                                    <th>#</th>
                                    <th style={{ textAlign: "right" }}>Customer Code</th>
                                    <th style={{ textAlign: "right" }}></th>
                                    <th style={{ textAlign: "right" }}>Name</th>
                                    <th style={{ textAlign: "right" }}>Barcode</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentPosts.map((item, index) => {
                                    const rowNumber = indexOfFirstPost + index
                                    return (
                                        <TableRow
                                            item={item}
                                            index={index}
                                            RemoveRow={RemoveRow}
                                            Disabled={Disabled}
                                            rowNumber={rowNumber}
                                            RowOnchange={RowOnchange}
                                            UpdateRow={UpdateRow}
                                        />
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm={12} md={6} className="mb-12-sm">
                    <Button
                        disabled={Disabled}
                        onClick={() => {
                            AddNewRow()
                        }}
                        color="success"
                        className="mt-1"
                        size="sm"
                    >
                        <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
                    </Button>
                </Col>
            </Row>
            <Row>
                {customerBarcodeList.length > 0 ? <Col sm={12} md={6} className="mb-12-sm">
                    <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(customerBarcodeList.length / postsPerPage)}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        forcePage={currentPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-center pagination-sm'}
                    />
                </Col> : null}
            </Row>
        </div>
    )
};


const TableRow = ({ item, index, RemoveRow, Disabled, rowNumber, RowOnchange, UpdateRow }) => {
    const authToken = localStorage.getItem("authToken");
    const ApiURL = window.Links.ApiURL;

    const getCustomer = async (customerCode) => {

        if (customerCode === "") return

        let currentRow = item

        try {

            const response = await fetch(`${ApiURL}Customer/search/${customerCode}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${authToken}`
                }
            });

            const responseData = await response.json();

            if (responseData.success) {

                currentRow.customerCode = responseData.data[0].strCode
                currentRow.customerName = responseData.data[0].strFullName

            }

        } catch (error) {
            console.log(error)
        }

    }


    return (
        <tr key={index} className="p-0 m-0">
            <td>
                <h5 className="font-size-12 mb-0">{rowNumber + 1}</h5>
            </td>
            <td>
                <DPTextBoxforgrid
                    value={item.customerCode}
                    name="customerCode"
                    index={index}
                    disabled={true}
                    onChange={(e) => {

                        const enteredText = Text(e.target, 15, true, false, 'any', false);
                        RowOnchange(enteredText, "customerCode", rowNumber)

                    }}
                    onBlur={(e) => {
                        getCustomer(e.target.value)
                    }}
                />
            </td>
            <td style={{ textAlign: "right" }}>
                <Button
                    outline
                    disabled={Disabled}
                    color="success"
                    id={"btnSearch" + index}
                    // onClick={clickSearch}
                    size="sm"
                >
                    <i
                        className="mdi mdi-search-web"
                        style={{ fontSize: "12px" }}
                    ></i>
                </Button>
            </td>
            <td style={{ textAlign: "right" }}>
                <DPTextBoxforgrid
                    value={item.customerName}
                    name="customerName"
                    index={index}
                    disabled={true}
                />
            </td>
            <td>
                <DPTextBoxforgrid
                    value={item.barcode}
                    name="barcode"
                    index={index}
                    disabled={true}
                    onChange={(e) => {

                        const enteredText = Text(e.target, 15, true, true, 'any', false);
                        RowOnchange(enteredText, "barcode", rowNumber)

                    }}
                />
            </td>
            <td>
                <Button
                    className="btn btn-link"
                    onClick={() => RemoveRow(index)}
                    disabled={Disabled}
                    color="danger"

                >
                    <i className="bx bx-trash"></i>
                </Button>
            </td>
        </tr>
    )
}